import { render, staticRenderFns } from "./PendapatanDetail.vue?vue&type=template&id=2e1675f2&scoped=true"
import script from "./PendapatanDetail.vue?vue&type=script&lang=js"
export * from "./PendapatanDetail.vue?vue&type=script&lang=js"
import style0 from "./PendapatanDetail.vue?vue&type=style&index=0&id=2e1675f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1675f2",
  null
  
)

export default component.exports